<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        template(v-if="parametersFrom === 'homework'")
            template(v-if='settings.amountOfExamples && !settings.timeLimit')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfExamples }}
                br
            template
                | {{ $i18n.t('battle.battle_battleForm_grades') }}: {{ classes }}
                br
            template(v-if='settings.timeLimit')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}:
                | {{ settings.timeLimit }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}
        slot

</template>

<script>
/*eslint-disable*/
import TrainerUtilities from '../../../utils/trainer/trainer';
import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

export default {
    mixins: [TrainerUtilities, gamePreviewMixin],
    props: {
        game: Object,
        parameters: Object,
        userId: Number,
        parametersFrom: {
            type: String,
            default: 'homework'
        }
    },
    computed: {
        classes() {
            return this.settings.selectedClasses
                .map(obj => this.$i18n.t('trainer.trainer_gameFormSetting_class_' + `${obj.value}`))
                .join('; ');
        },
    },
}
</script>
